import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonDirective } from '../../directives/button.directive';
import { ResizeDirective } from '../../directives/resize.directive';
import { SvgComponent } from '../svg/svg.component';

@Component({
  selector: 'app-website-footer',
  templateUrl: './website-footer.component.html',
  styleUrls: ['./website-footer.component.scss'],
  standalone: true,
  imports: [ResizeDirective, RouterLink, NgIf, SvgComponent, ButtonDirective],
})
export class WebsiteFooterComponent {
  @Input() dark: boolean;
  @Input() black: boolean;
  currentYear = new Date().getFullYear();
}
